// src/components/SportDropdown.js
import React from 'react';
import PropTypes from 'prop-types';
import styles from './SportDropdown.module.css';

const SportDropdown = ({ value, onChange }) => {
  return (
    <div className={styles.dropdownContainer}>
      <label htmlFor="sport">Select sport</label>
      <select id="sport" name="sport" value={value} onChange={onChange}>
        <option value="" disabled>Select a sport</option>
        <option value="Baseball">Baseball</option>
        <option value="Football">Football</option>
        <option value="Basketball">Basketball</option>
      </select>
    </div>
  );
};

SportDropdown.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SportDropdown;
